import {
  Autocomplete,
  Box,
  Button,
  Chip,
  CircularProgress,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Select,
  TextField,
  Tooltip,
  Typography,
  Paper,
  Stack,
  alpha,
  Divider,
} from '@mui/material';
import { useEffect, useState } from 'react';
import { withRouter } from 'react-router';
import { openNotification } from '../../../helpers/notification';
import { getFacilityByUserId, getInvoices } from '../../../helpers/api';
import LoaderSkeleton from '../../common/LoaderSkeleton';
import { Empty } from 'antd';
import MUIDataTable from 'mui-datatables';
import {
  GroupsOutlined,
  MoreHoriz,
  Payment,
  ReceiptLongOutlined,
  BusinessRounded,
  HistoryOutlined,
  FilterList,
} from '@mui/icons-material';
import { invoiceStatusList, userCats } from '../../../helpers/appstate';
import { getYears } from '../../../helpers/dateHelpers';
import FacilityPaymentOffline from '../facilities2/facility-invoices/FacilityPaymentOffline';
import FacilityPaymentList from '../facilities2/facility-invoices/FacilityPaymentList';
import { FacilityPaymentOnline } from '../facilities2/facility-invoices/FacilityPaymentOnline';
import PaymentOption from '../facilities2/facility-invoices/PaymentOption';
import InvoiceRecipients from '../facilities2/facility-invoices/InvoiceRecipients';
import { Link } from 'react-router-dom';

const InvoiceScreen = withRouter(({ props }) => {
  const { userCategory, userPermission, userId } = props;
  const userPerm = userPermission?.map((i) => i?.trim()?.toLowerCase()) || [];
  const viewPayments = userPerm.includes('view_payment');

  const [invoiceList, setInvoiceList] = useState([]);
  const [invoiceLoading, setInvoiceLoading] = useState(false);
  const [row, setRow] = useState();
  const [selectedInvoiceId, setSelectedInvoiceId] = useState('');
  const [search, setSearch] = useState('');
  const [invoiceStatus, setInvoiceStatus] = useState(invoiceStatusList[0]?.value);
  const [reportId, setReportId] = useState('');
  const [anchorOverflowMenuEl, setAnchorOverflowMenuEl] = useState(null);
  const [facilityList, setFacilityList] = useState([]);
  const [facilityLoading, setFacilityLoading] = useState(false);
  const [facilitySelected, setFacilitySelected] = useState({ facilityId: '', facilityName: '' });

  const [showPaymentOptions, setShowPaymentOptions] = useState(false);
  const [selectedPaymentOption, setSelectedPaymentOption] = useState();
  const [showPaymentList, setShowPaymentList] = useState(false);
  const [showOfflinePaymentAdd, setShowOfflinePaymentAdd] = useState(false);
  const [showOnlinePaymentAdd, setShowOnlinePaymentAdd] = useState(false);
  const [showInvoiceRecipients, setShowInvoiceRecipients] = useState(false);

  console.log(invoiceList);

  useEffect(() => {
    fetchInvoiceList();
  }, [invoiceStatus, facilitySelected?.facilityId]);

  useEffect(() => {
    fetchFacilities();
  }, []);

  const handleOverflowMenuClick = (event) => setAnchorOverflowMenuEl(event.currentTarget);
  const handleOverflowMenuClose = () => setAnchorOverflowMenuEl(null);

  const fetchInvoiceList = async () => {
    setInvoiceLoading(true);
    try {
      // Fetching a large set (1000) so mui-datatables can handle pagination on the frontend
      const res = await getInvoices(
        search,
        facilitySelected?.facilityId,
        invoiceStatus,
        reportId,
        1,
        1000
      );
      const { data, status } = res?.result;
      if (status?.code === '00') {
        setInvoiceList(data);
      } else {
        openNotification({ type: 'error', message: status?.desc });
      }
    } catch (err) {
      console.error(err);
    } finally {
      setInvoiceLoading(false);
    }
  };

  const fetchFacilities = async () => {
    setFacilityLoading(true);
    try {
      const res = await getFacilityByUserId(userId);
      if (res.status === 200) setFacilityList(res.data);
    } catch (err) {
      console.error(err);
    } finally {
      setFacilityLoading(false);
    }
  };

  const renderDisplay = () => {
    const columns = [
      {
        name: 'invoiceNo',
        label: 'Invoice Info',
        options: {
          customHeadLabelRender: (a) => (
            <Typography
              variant="button"
              fontWeight={700}
              color="text.secondary"
              sx={{ fontSize: '0.75rem' }}
            >
              {a.label}
            </Typography>
          ),
          customBodyRenderLite: (index) => {
            const item = invoiceList[index];
            return (
              <Stack direction="row" spacing={2} alignItems="center" sx={{ py: 1 }}>
                <Box
                  sx={{
                    p: 1,
                    borderRadius: '10px',
                    bgcolor: alpha('#1976d2', 0.1),
                    color: 'primary.main',
                    display: 'flex',
                  }}
                >
                  <ReceiptLongOutlined sx={{ fontSize: 18 }} />
                </Box>
                <Box>
                  <a
                    href={item?.fileUrl}
                    target="_blank"
                    rel="noreferrer"
                    style={{ textDecoration: 'none' }}
                  >
                    <Typography
                      variant="body2"
                      fontWeight={700}
                      color="primary"
                      sx={{ '&:hover': { textDecoration: 'underline' } }}
                    >
                      {item.invoiceNo}
                    </Typography>
                  </a>
                  <Typography
                    variant="caption"
                    color="textSecondary"
                    sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}
                  >
                    <HistoryOutlined sx={{ fontSize: 12 }} />
                    {new Date(item.entryDate).toLocaleDateString('en-NG', {
                      month: 'short',
                      day: 'numeric',
                      year: 'numeric',
                    })}
                  </Typography>
                </Box>
              </Stack>
            );
          },
        },
      },
      {
        name: 'facilityName',
        label: 'Facility Details',
        options: {
          customHeadLabelRender: (a) => (
            <Typography
              variant="button"
              fontWeight={700}
              color="text.secondary"
              sx={{ fontSize: '0.75rem' }}
            >
              {a.label}
            </Typography>
          ),
          customBodyRenderLite: (index) => (
            <Stack direction="row" spacing={2} alignItems="center">
              <Box
                sx={{
                  p: 1,
                  borderRadius: '10px',
                  bgcolor: alpha('#1976d2', 0.1),
                  color: 'primary.main',
                  display: 'flex',
                }}
              >
                <BusinessRounded sx={{ fontSize: 18 }} />
              </Box>
              <Link
                to={`/facilities/${invoiceList[index].facilityId}/view`}
                style={{ textDecoration: 'none' }}
              >
                <Typography
                  variant="body2"
                  fontWeight={700}
                  color="primary"
                  sx={{ '&:hover': { textDecoration: 'underline' } }}
                >
                  {invoiceList[index].facilityName}
                </Typography>
              </Link>
            </Stack>
          ),
        },
      },
      // --- ADDED REPORT TITLE COLUMN HERE ---
      {
        name: 'reportTitle',
        label: 'Linked Report',
        options: {
          customHeadLabelRender: (a) => (
            <Typography
              variant="button"
              fontWeight={700}
              color="text.secondary"
              sx={{ fontSize: '0.75rem' }}
            >
              {a.label}
            </Typography>
          ),
          customBodyRenderLite: (index) => (
            <Box>
              <Typography variant="body2" color="text.primary">
                {invoiceList[index].reportTitle || 'N/A'}
              </Typography>
              {/* <Typography variant="caption" color="textSecondary">
                {invoiceList[index].reportType || 'General'}
              </Typography> */}
            </Box>
          ),
        },
      },
      // ---------------------------------------
      {
        name: 'totalAmount',
        label: 'Amount (NGN)',
        options: {
          customHeadLabelRender: (a) => (
            <Typography
              variant="button"
              fontWeight={700}
              color="text.secondary"
              sx={{ fontSize: '0.75rem' }}
            >
              {a.label}
            </Typography>
          ),
          customBodyRenderLite: (index) => (
            <Box>
              <Typography variant="body2" fontWeight={700}>
                {new Intl.NumberFormat('en-NG', { style: 'currency', currency: 'NGN' }).format(
                  invoiceList[index].totalAmount
                )}
              </Typography>
              <Typography variant="caption" color="error.main" fontWeight={600}>
                {invoiceList[index].outstandingAmount > 0 &&
                  `Due: ${new Intl.NumberFormat('en-NG', {
                    style: 'currency',
                    currency: 'NGN',
                  }).format(invoiceList[index].outstandingAmount)}`}
              </Typography>
            </Box>
          ),
        },
      },
      {
        name: 'invoiceStatus',
        label: 'Status',
        options: {
          customHeadLabelRender: (a) => (
            <Typography
              variant="button"
              fontWeight={700}
              color="text.secondary"
              sx={{ fontSize: '0.75rem' }}
            >
              {a.label}
            </Typography>
          ),
          customBodyRenderLite: (index) => {
            const status = invoiceList[index].invoiceStatus;
            const isClosed = status === 'CLOSED';
            const themeColor = isClosed ? '#2e7d32' : status === 'OPEN' ? '#d32f2f' : '#ed6c02';
            return (
              <Chip
                label={status}
                size="small"
                sx={{
                  fontWeight: 700,
                  fontSize: '0.65rem',
                  bgcolor: alpha(themeColor, 0.1),
                  color: themeColor,
                  borderRadius: '6px',
                }}
              />
            );
          },
        },
      },
    ];

    if (userCategory === userCats.EDM) {
      columns.push({
        name: '',
        label: 'Actions',
        options: {
          customHeadLabelRender: (a) => (
            <Typography
              variant="button"
              fontWeight={700}
              color="text.secondary"
              sx={{ fontSize: '0.75rem' }}
              align="center"
            >
              {a.label}
            </Typography>
          ),
          customBodyRenderLite: (index) => (
            <Box align="center">
              <IconButton
                size="small"
                onClick={(e) => {
                  setRow(invoiceList[index]);
                  handleOverflowMenuClick(e);
                }}
                sx={{ bgcolor: alpha('#000', 0.03) }}
              >
                <MoreHoriz />
              </IconButton>
            </Box>
          ),
        },
      });
    }

    return (
      <MUIDataTable
        data={invoiceList}
        columns={columns}
        options={{
          elevation: 0,
          selectableRows: 'none',
          responsive: 'standard',
          // MUI DATA TABLE PAGINATION ENABLED
          pagination: true,
          rowsPerPage: 10,
          rowsPerPageOptions: [10, 25, 50],
          print: false,
          download: false,
          filter: false,
          search: false,
          viewColumns: false,
          textLabels: {
            pagination: {
              next: 'Next Page',
              previous: 'Previous Page',
              rowsPerPage: 'Rows per page:',
              displayRows: 'of',
            },
          },
          setRowProps: (ev, dataIndex) => ({
            style: { backgroundColor: dataIndex % 2 === 0 ? '#ffffff' : alpha('#f5f7ff', 0.5) },
          }),
          setTableProps: () => ({
            size: 'small',
            sx: {
              '& .MuiTableCell-root': {
                borderBottom: '1px solid',
                borderColor: alpha('#000', 0.05),
              },
            },
          }),
        }}
      />
    );
  };

  return (
    <Box sx={{ p: { xs: 2, md: 4 }, bgcolor: '#F4F6F8', minHeight: '100vh', mt: -1 }}>
      {/* HEADER SECTION */}
      <Paper
        elevation={0}
        sx={{ p: 2.5, mb: 3, borderRadius: '16px', border: '1px solid', borderColor: 'divider' }}
      >
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          justifyContent="space-between"
          alignItems="center"
          spacing={2}
        >
          <Box>
            <Typography variant="h5" fontWeight={700} color="text.primary">
              Billing & Invoices
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Review status and manage payments for facility invoices.
            </Typography>
          </Box>

          <Stack direction="row" spacing={1.5}>
            <Select
              value={invoiceStatus}
              size="small"
              placeholder="Status"
              onChange={(e) => setInvoiceStatus(e.target.value)}
              startAdornment={<FilterList sx={{ fontSize: 18, mr: 1, color: 'text.secondary' }} />}
              sx={{ borderRadius: '12px', minWidth: 140, bgcolor: '#f9fafb' }}
            >
              {invoiceStatusList?.map((i) => (
                <MenuItem key={i?.value} value={i?.value}>
                  {i?.label}
                </MenuItem>
              ))}
            </Select>

            <Autocomplete
              options={facilityList}
              getOptionLabel={(option) => option.facilityName || ''}
              value={facilitySelected.facilityId ? facilitySelected : null}
              onChange={(e, value) =>
                setFacilitySelected(value || { facilityId: '', facilityName: '' })
              }
              size="small"
              sx={{ width: 240 }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Filter by facility"
                  InputProps={{
                    ...params.InputProps,
                    sx: { borderRadius: '12px', bgcolor: '#f9fafb' },
                    startAdornment: (
                      <>
                        {facilityLoading && <CircularProgress size={16} sx={{ mr: 1 }} />}
                        {params.InputProps.startAdornment}
                      </>
                    ),
                  }}
                />
              )}
            />
          </Stack>
        </Stack>
      </Paper>

      {/* MAIN DATA TABLE AREA */}
      <Paper
        elevation={0}
        sx={{
          borderRadius: '16px',
          border: '1px solid',
          borderColor: 'divider',
          overflow: 'hidden',
        }}
      >
        {invoiceLoading ? (
          <Box sx={{ p: 4 }}>
            <LoaderSkeleton />
            <Divider sx={{ my: 2 }} />
            <LoaderSkeleton />
          </Box>
        ) : invoiceList?.length < 1 ? (
          <Box sx={{ py: 10, textAlign: 'center' }}>
            <Empty description="No billing records found matching your criteria" />
          </Box>
        ) : (
          renderDisplay()
        )}
      </Paper>

      {/* OVERFLOW MENU FOR EDM ACTIONS */}
      <Menu
        anchorEl={anchorOverflowMenuEl}
        open={Boolean(anchorOverflowMenuEl)}
        onClose={handleOverflowMenuClose}
        PaperProps={{
          sx: {
            borderRadius: '12px',
            mt: 1,
            width: 220,
            boxShadow: '0 10px 40px rgba(0,0,0,0.1)',
            border: '1px solid',
            borderColor: 'divider',
          },
        }}
      >
        <MenuItem
          onClick={() => {
            setShowInvoiceRecipients(true);
            handleOverflowMenuClose();
          }}
        >
          <ListItemIcon>
            <GroupsOutlined fontSize="small" />
          </ListItemIcon>
          <ListItemText
            primary="View Recipients"
            primaryTypographyProps={{ variant: 'body2', fontWeight: 600 }}
          />
        </MenuItem>

        {viewPayments && (
          <MenuItem
            onClick={() => {
              setShowOfflinePaymentAdd(true);
              handleOverflowMenuClose();
            }}
          >
            <ListItemIcon>
              <Payment fontSize="small" color="primary" />
            </ListItemIcon>
            <ListItemText
              primary="Manage Payments"
              primaryTypographyProps={{ variant: 'body2', fontWeight: 600 }}
            />
          </MenuItem>
        )}
      </Menu>

      {/* RENDER MODALS (Functionality preserved) */}
      {showPaymentOptions && (
        <PaymentOption
          open={showPaymentOptions}
          props={props}
          onClose={() => setShowPaymentOptions(false)}
          onSelectOption={(opt) => {
            setSelectedPaymentOption(opt);
            opt?.method === 'OFFLINE'
              ? setShowOfflinePaymentAdd(true)
              : setShowOnlinePaymentAdd(true);
          }}
        />
      )}
      {showOnlinePaymentAdd && (
        <FacilityPaymentOnline
          open={showOnlinePaymentAdd}
          onViewPayments={(id) => {
            setShowOfflinePaymentAdd(false);
            setShowPaymentList(true);
            setSelectedInvoiceId(id);
          }}
          onClose={() => setShowOnlinePaymentAdd(false)}
          invoiceRecord={row}
          paymentOption={selectedPaymentOption}
        />
      )}
      {showPaymentList && (
        <FacilityPaymentList
          open={showPaymentList}
          invoiceId={selectedInvoiceId}
          props={props}
          onAddPayments={(id) => {
            setSelectedInvoiceId(id);
            setShowPaymentList(false);
            setShowOfflinePaymentAdd(true);
          }}
          onClose={() => setShowPaymentList(false)}
        />
      )}
      {showOfflinePaymentAdd && (
        <FacilityPaymentOffline
          open={showOfflinePaymentAdd}
          props={props}
          invoiceItem={row}
          onClose={() => setShowOfflinePaymentAdd(false)}
        />
      )}
      {showInvoiceRecipients && (
        <InvoiceRecipients
          props={props}
          open={showInvoiceRecipients}
          onClose={() => setShowInvoiceRecipients(false)}
          invoiceItem={row}
        />
      )}
    </Box>
  );
});

export default InvoiceScreen;
